import { render, staticRenderFns } from "./edit-status-modal.vue?vue&type=template&id=1a61a1f6&scoped=true&"
import script from "./edit-status-modal.vue?vue&type=script&lang=js&"
export * from "./edit-status-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61a1f6",
  null
  
)

export default component.exports